module.exports = __webpack_public_path__ + "images/icons/size-guide/vehicle-10x50.svg";